<template>
  <div class="page-content">
    <div class="headings">
      <h2 class="title title-primary">
        {{ $t("lang.movement.box_detail.page_title_line_1") }}
      </h2>
      <span>|</span>
      <h3 class="title title-primary">
        {{ $t("lang.movement.box_detail.page_title_line_2") }}
      </h3>
    </div>
    <div class="page-header">
      <div class="boxes" v-if="!shouldLoading">
        <bx-box
          dark
          color="outline"
          :title="$t('lang.movement.box_detail.box_title_1')"
          class="col-12 col-md-6 col-lg-auto p-1"
        >
          <template slot="actions">
            <bx-order-status
              :status="order_status"
              dark
            ></bx-order-status>
          </template>
          <div class="detail-titles">
            <div class="wrapper">
              <h4>
                Nº
                <strong>{{ id }}</strong>
              </h4>
              <h5>
                <strong>{{ name }}</strong>
              </h5>
            </div>
          </div>
        </bx-box>

        <bx-box dark color="outline" class="col-6 col-md-6 col-lg-auto p-1">
          <bx-value
            :label="$t('lang.inbound.order_boxes.box_label_2')"
            :value="receptionTime"
            font-size="xs"
          />
        </bx-box>

        <bx-box
          dark
          color="outline"
          class="col-6 col-md-4 col-lg-auto p-1 bx-box-adjustable"
        >
          <bx-value
            :label="$t('lang.inbound.order_boxes.box_label_3')"
            :value="waitingTime"
            font-size="xs"
          />
        </bx-box>

        <bx-box dark color="outline" class="col-6 col-md-4 col-lg-auto p-1">
          <bx-value
            :label="$t('lang.inbound.order_boxes.box_label_4')"
            :value="`${orderData.origin_real_item_count} / ${orderData.item_count}`"
            font-size="xs"
          />
        </bx-box>

        <bx-box dark color="outline" class="col-6 col-md-4 col-lg-auto p-1">
          <bx-value
            :label="$t('lang.inbound.order_boxes.box_label_5')"
            :value="`${orderData.origin_num_verified_boxes} / ${orderData.num_boxes}`"
            font-size="xs"
          />
        </bx-box>
      </div>
      <skeleton-boxes :boxes="5" v-else />
    </div>

    <div class="page-main-content">
      <div class="container-fluid">
        <div class="row" style="margin: 8px">
          <bx-btn @click="$router.back()">{{
            $t("lang.messages.go_back")
          }}</bx-btn>
        </div>
        <v-row class="d-flex d-sm-none">
          <v-list width="100%">
            <v-list-item
              two-line
              v-for="(item, index) in data"
              :key="index"
              class="green lighten-5 ma-2 rounded-lg"
              ripple
              :to="`/inbound/order/${orderId}/gtin/${item.itemType}/detail`"
            >
              <v-list-item-content>
                <v-list-item-title>
                  {{ item.gtin }}
                </v-list-item-title>
                <v-list-item-title class="text-caption">
                  {{ item.description }}
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-list-item-subtitle class="text-caption">
                  {{ item.quantity_real + "/" + item.quantity }}
                </v-list-item-subtitle>
                <v-list-item-subtitle class="text-caption">
                  {{ item.color }}
                </v-list-item-subtitle>

                <v-list-item-subtitle class="text-caption">
                  {{ item.size }}
                </v-list-item-subtitle>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-row>
        <div class="row">
          <bx-box
            :title="
              itemCount + ' ' + $t('lang.box_verifications_report.label_title')
            "
            color="white"
            no-padding
            class="col-12"
            :loading="shouldLoading"
          >
            <template v-slot:default>
              <skeleton-table :columns="10" v-if="shouldLoading" />

              <bx-table
                :data="data"
                :columns="columns"
                paginated
                v-if="!shouldLoading"
                backendPagination
                :currentPage="page"
                :perPage="itemsPerPage"
                :total="itemCount"
                @update:currentPage="updatePage"
              >
                <template slot-scope="props">
                  <bx-table-column>
                    <router-link
                      :to="
                        `/inbound/order/${orderId}/gtin/${props.row.itemType}/detail`
                      "
                      class="bx-link bx-link-bold"
                      >{{ props.row.gtin }}</router-link
                    >
                  </bx-table-column>
                  <bx-table-column>{{ props.row.quantity }}</bx-table-column>
                  <bx-table-column>{{
                    props.row.quantity_real
                  }}</bx-table-column>
                  <bx-table-column>{{ props.row.description }}</bx-table-column>
                  <bx-table-column>{{ props.row.section }}</bx-table-column>
                  <bx-table-column>{{ props.row.cloth_type }}</bx-table-column>
                  <bx-table-column>{{ props.row.model }}</bx-table-column>
                  <bx-table-column>{{ props.row.color }}</bx-table-column>
                  <bx-table-column>{{ props.row.size }}</bx-table-column>
                  <bx-table-column v-if="props.row.ratingPercent > 100">
                    <bx-complementary-mini
                      :percent="100"
                    ></bx-complementary-mini>
                  </bx-table-column>
                  <bx-table-column v-if="props.row.ratingPercent <= 100">
                    <bx-complementary-mini
                      :percent="props.row.ratingPercent"
                    ></bx-complementary-mini>
                  </bx-table-column>
                </template>
              </bx-table>
            </template>
          </bx-box>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BxBtn from "@/bx-components/BxBtn";
import BxReceptionBoxStatus from "@/bx-components/BxReceptionBoxStatus";

export default {
  props: ["orderId", "boxId", "id"],
  components: { BxReceptionBoxStatus, BxBtn },
  data() {
    return {
      shouldLoading: true,
      columns: [],
      data: [],
      orderData: null,
      receptionTime: "",
      waitingTime: "",
      name: "",
      order_status: 0,
      itemCount: 0,
      itemsPerPage: process.env.VUE_APP_GTIN_PER_PAGE,
      page: 1,
      reloadInterval: null
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    updatePage(p) {
      this.page = p;
      this.getData();
    },
    async getData() {
      this.orderData = await this.$api.morders.get(this.orderId);
      this.receptionTime = this.orderData.arrival_date;
      this.order_status = this.orderData.destination_status;
      this.waitingTime = this.orderData.origin_waiting_time;
      this.name = this.orderData.order_name;

      let verifications = await this.$api.porders.getVerificationReport(
        this.id,
        {
          offset: (this.page - 1) * this.itemsPerPage,
          limit: this.itemsPerPage
        }
      );
      this.itemCount = verifications.count;

      this.data = verifications.results.map((item, key) => {
        return {
          gtin: item.gtin,
          itemType: item.item_type,
          quantity: item.real_item_count,
          quantity_real:
            item.theorical_item_count !== null ? item.real_item_count : 0,
          cloth_type: item.cloth_type,
          id: item.id,
          size: item.size,
          color: item.colour,
          model: item.model,
          description: item.description,
          section: item.section,
          ratingPercent:
            (item.real_item_count / item.theorical_item_count) * 100
        };
      });

      this.columns = [
        {
          field: "gtin",
          label: this.$t("lang.inbound.order_detail.table_field_1")
        },
        {
          field: "quantity",
          label: this.$t("lang.inbound.order_detail.table_field_2")
        },
        {
          field: "real_quantity",
          label: this.$t("lang.inbound.order_detail.table_field_3")
        },
        {
          field: "description",
          label: this.$t("lang.inbound.order_detail.description")
        },
        {
          field: "section",
          label: this.$t("lang.inbound.order_detail.table_field_4")
        },
        {
          field: "itemtype",
          label: this.$t("lang.inbound.order_detail.table_field_5")
        },
        {
          field: "model",
          label: this.$t("lang.inbound.order_detail.table_field_6")
        },
        {
          field: "color",
          label: this.$t("lang.inbound.order_detail.table_field_7")
        },
        {
          field: "size",
          label: this.$t("lang.inbound.order_detail.table_field_8")
        },
        {
          field: "ratingPercent",
          label: this.$t("lang.inbound.order_detail.table_field_9"),
          width: 200
        }
      ];
      this.shouldLoading = false;
    }
  }
};
</script>
